<script lang="ts" setup>
import UserAvatar from "@/components/UserAvatar.vue";
import { timeAgo } from "@/modules/common";
import { useChatSession } from "@/stores/chatSession";
import { ChatSceneTarget } from "@/types/chat";
import { useDefaultAvatar } from "@/use/common";
import { computed } from "vue";

// Props & Emit
interface MessageItem {
  sessionId: number;
  avatarUrl?: string;
  name?: string;
  message?: string;
  time: string;
  unread?: number;
  rows?: number;
}

const props = withDefaults(defineProps<MessageItem>(), {
  avatarUrl: useDefaultAvatar(),
  name: "",
  message: "",
  unread: 0,
  rows: 1,
});

const sessionStore = useChatSession();
const currentSession = computed(() => {
  return sessionStore.sessionMap[props.sessionId];
});
const endingTarget = computed(() => {
  return currentSession.value?.chatScene?.targetzz?.find(
    (target) =>
      target.id === currentSession.value?.chatSceneStatus?.endingTargetId
  ) as ChatSceneTarget | undefined;
});
</script>
<template>
  <div class="grid grid-cols-[auto_1fr_auto] p-2 border-b justify-between">
    <div class="indicator">
      <span
        v-if="unread && unread > 0"
        class="indicator-item badge badge-primary badge-sm"
      >
        {{ unread }}
      </span>
      <user-avatar :avatar-url="avatarUrl" class="h-16 shrink-0 mr-2" />
    </div>
    <div class="flex flex-col flex-grow overflow-hidden">
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-1">
          <span class="text msg-name">
            {{ name }}
          </span>
          <span
            v-if="currentSession.chatScene?.targetzz?.length > 0"
            class="flex items-center gap-1"
          >
            <span class="badge badge-sm badge-outline roudned">
              {{ $t("Chats.game") }}
            </span>
            <span
              v-if="currentSession.chatSceneStatus?.endingTargetId"
              class="badge badge-sm roudned badge-outline"
              :class="
                endingTarget?.type === 1 ? 'badge-warning' : 'badge-error'
              "
            >
              {{
                endingTarget?.type === 1
                  ? $t("Chats.success")
                  : $t("Chats.failed")
              }}
            </span>
          </span>
        </div>
        <div class="text-xs text-base-content/50 shrink-0">
          {{ timeAgo(time) }}
        </div>
      </div>
      <div class="line-clamp-2 text-base-content/50">
        {{ message }}
      </div>
    </div>
  </div>
</template>
